import axios from "axios";
import { serverUrl } from '@platform/config';

const endpoint = `${serverUrl}/api/UserEntityAllocation`;

export async function userEntityAllocationApiAllocateEntity(tableId: string): Promise<string | null> {
    const resp = await axios.post(`${endpoint}/AllocateEntity`, JSON.stringify({ tableId }));
    return resp.data;
}